// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_OrderCanceled_box-4pJumNt"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/order-canceled/components/OrderCanceled.scss
// module id = 1792
// module chunks = 0